import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { heading5Obj } = typographyStyles;

export const bundleRowContainerCss: CSSObject = {
  padding: "1.5rem",
  borderRadius: "1rem",
  background: constants.colors.ui.neutral[25],
  marginBottom: "1.5rem",
  "&:first-of-type": {
    marginTop: "1.5rem",
  },
  "&:last-of-type": {
    marginBottom: 0,
  },
  display: "grid",
  gridTemplateColumns: "1rem 1fr 1rem",
  gridTemplateRows: "auto auto 1fr",
  border: `1px solid ${constants.colors.ui.neutral[50]}`,
};

export const defaultHeadingCss: CSSObject = {
  fontSize: "24px",
  lineHeight: "133%",
  fontWeight: 700,
  height: "32px",
  color: constants.colors.ui.neutral[700],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headerDescriptionCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...heading5Obj,
  lineHeight: "137.5%",
  color: constants.colors.ui.neutral[600],
};

export const headerIconCss: CSSObject = {
  marginRight: "5px",
  width: "24px",
  height: "24px",
};

export const headerAndDescriptionContainerCss: CSSObject = {
  gridColumn: "1 / -1",
  gridRow: "1 / 3",
  display: "flex",
  flexDirection: "column",
  marginBottom: "16px",
};

export const linkCss = {
  root: {
    color: constants.colors.ui.core[700],
  },
};

export const contentScrollableListCss: CSSObject = {
  display: "flex",
  gap: 12,
  padding: 0,
  margin: 0,
  listStyle: "none",
  alignItems: "stretch",
};

export const listItemCss: CSSObject = {
  flex: "0 0 clamp(240px, 28vw, 320px)",
  "& > *": {
    height: "100%",
    display: "grid",
  },
};
